/**
 * Mock client-portal data — interim contract for features/client-portal/*.
 * Read-only from the client's perspective (no-config guarantee): every mutation
 * affordance is a "request" that can never change platform state.
 */
export const clientProfile = {
  id: 'tenant-helios',
  name: 'Helios Logistics',
  slug: 'helios-logistics',
  logoUrl: '',
  primaryColor: '#0f8a5f',
  plan: 'Growth',
  accountManager: { name: 'Sarah Chen', role: 'Agency admin', email: 'sarah@example.com' },
  contract: { renewsOn: '2026-12-01', autorenew: true }
};

export const clientKpis = [
  { id: 'hours-saved', label: 'Hours saved', value: '412', delta: '+38 this week', tone: 'positive' },
  { id: 'tasks-completed', label: 'Tasks completed', value: '1,204', delta: '+96 this week', tone: 'positive' },
  { id: 'cost-outcome', label: 'Cost per outcome', value: '$3.10', delta: '↓ 12% this month', tone: 'positive' },
  { id: 'open-requests', label: 'Open change requests', value: '2', delta: '1 under review', tone: 'neutral' }
];

export const clientAgents = [
  { id: 2, name: 'Scout', role: 'Research', status: 'running', summary: 'Compiles weekly market intelligence briefs from 40+ sources.' },
  { id: 3, name: 'Quill', role: 'Content', status: 'running', summary: 'Drafts customer stories and channel variants for review.' },
  { id: 5, name: 'Ledger', role: 'Finance', status: 'autonomous', summary: 'Reconciles invoices and flags anomalies above $500.' }
];

export const clientActivity = [
  { id: 'ca-4', agent: 'Ledger', text: 'Closed invoice #4821 after reconciliation — no discrepancies found.', time: '12m ago', tone: 'success' },
  { id: 'ca-3', agent: 'Quill', text: 'Drafted the autumn freight story and sent it to the agency for review.', time: '1h ago', tone: 'neutral' },
  { id: 'ca-2', agent: 'Scout', text: 'Delivered the weekly competitor brief to your document library.', time: '3h ago', tone: 'success' },
  { id: 'ca-1', agent: 'Atlas', text: 'Escalated a $2,400 credit request to the agency for approval.', time: 'Yesterday', tone: 'attention' }
];

export const clientInvoices = [
  { id: 'INV-2026-09', period: 'September 2026', amount: 4820, status: 'paid', issuedOn: '2026-09-01' },
  { id: 'INV-2026-08', period: 'August 2026', amount: 4610, status: 'paid', issuedOn: '2026-08-01' },
  { id: 'INV-2026-07', period: 'July 2026', amount: 5090, status: 'paid', issuedOn: '2026-07-01' },
  { id: 'INV-2026-10', period: 'October 2026 (draft)', amount: 3985, status: 'draft', issuedOn: '2026-10-01' }
];

export const clientUsage = {
  period: 'October 2026',
  includedTasks: 1500,
  usedTasks: 812,
  includedAgentHours: 900,
  usedAgentHours: 507
};

export const supportTranscript = [
  { id: 's-1', author: 'agent', text: 'Hi Miles — Agent 9 here. Ask me anything about your account, invoices, or running work.', time: '09:00' },
  { id: 's-2', author: 'client', text: 'Can I get a breakdown of last month’s invoice?', time: '09:02' },
  { id: 's-3', author: 'agent', text: 'September’s invoice totals $4,820: 1,204 tasks at the Growth plan rate plus $310 of agent-hours overage. I’ve added the itemised PDF to your document library.', time: '09:02' }
];

export const clientChangeRequests = [
  { id: 'cr-1', title: 'Add WhatsApp delivery for freight alerts', status: 'under-review', filedOn: '2026-09-14' },
  { id: 'cr-2', title: 'Raise monthly task limit to 2,000', status: 'under-review', filedOn: '2026-09-18' }
];
